import './vendor.ts';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}
localStorage.setItem('date_chargement', JSON.stringify(new Date().toString()));
localStorage.setItem('date_livraison', JSON.stringify(environment.date));

const p = platformBrowserDynamic().bootstrapModule(AppModule);
p.then(() => { (<any>window).appBootstrap && (<any>window).appBootstrap(); });
// .catch(err => console.error(err));



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/main.ts